// Rene hjelpere bak kontaktkortet i Feltveksleren.
//
// ── HVORFOR DE BOR HER OG IKKE I `sentralbord.ts` ───────────────────────────
// `sentralbord.ts` er DOM fra første linje, og apps/cop har ingen jsdom
// (SENS-30) — så alt som ligger der er utestbart. De to funksjonene her er
// nettopp de som kan REGNES FEIL, og de avgjør om kontaktkortet lyver:
//
//  • `alderTekstKort` — «finn i kartet» uten alder er en påstand om at personen
//    ER der. Et spor på ni minutter er «her VAR han».
//  • `nyesteSporForPerson` — samme person kan ha flere spor (BFT, geotag,
//    bilde). Flyr vi til det FØRSTE treffet, kan operatøren havne på et punkt
//    fra i går mens et ferskt finnes.
import type { Track } from '@skade/contracts';

/**
 * Kort alder («9 min», «2 t», «3 døgn»).
 *
 * ⚠ NEGATIV ALDER GIR «ukjent tid», IKKE «-4 min». Et tidsstempel i framtida
 * (klokkeavvik mellom telefon og hub er normalt) skal ikke vises som et negativt
 * tall — det leses som om systemet vet noe det ikke vet.
 */
export function alderTekstKort(ms: number): string {
  if (!Number.isFinite(ms) || ms < 0) return 'ukjent tid';
  const min = Math.round(ms / 60_000);
  if (min < 1) return 'under 1 min';
  if (min < 90) return `${min} min`;
  const t = Math.round(ms / 3_600_000);
  return t < 48 ? `${t} t` : `${Math.round(ms / 86_400_000)} døgn`;
}

/** Eksponert for test — samme funksjon, tydelig navn på kallstedet. */
export const _testAlderTekstKort = alderTekstKort;

/**
 * Nyeste spor for en person, eller `null`.
 *
 * ⚠ SPOR UTEN `person.matrixId` PLUKKES ALDRI. Uten den sjekken kunne «finn
 * ham» flydd til en tilfeldig deteksjon som tilfeldigvis lå i lista.
 */
export function nyesteSporForPerson(
  spor: readonly Track[],
  matrixId: string,
): Track | null {
  let best: Track | null = null;
  for (const t of spor) {
    if (t.person?.matrixId !== matrixId) continue;
    if (!best || (t.tsMs || 0) > (best.tsMs || 0)) best = t;
  }
  return best;
}
